<template lang="pug">
.competitors-list
  //- TODO: add @vuetable:loaded="hideCompetitors" to vuetable
  vuetable.vuetable.w-100(
    :css="css.table"
    :table-height="tableHeight"
    :api-mode="false"
    :data="localData"
    :sort-order="sortingOrderDup"
    :data-manager="dataManager"
    :fields="fields"
    :no-data-template="$t('competitors_page.no_competitors')"
  )
    template(slot="number" slot-scope="props")
      span(:id="props.rowData.number").number.competitor-number {{ props.rowData.number }}

    template(slot="area", slot-scope="props")
      | {{ $n(props.rowData.area, 'number') }}

    template(slot="distance", slot-scope="props")
      | {{ $n(props.rowData.distance, 'number') }}

    template(slot="basic_unit_price", slot-scope="props")
      | {{ $n(props.rowData.basic_unit_price, 'number') }}

    template(slot="rent_fee", slot-scope="props")
      div {{ $n(props.rowData.month_money, 'number') }}
      div ({{ $n(props.rowData.money_maintenance_number, 'number') }})

    template(slot="building_structure", slot-scope="props")
      | {{ $t(`building_structure.${props.rowData.building_structure}`) }}

    template(slot="source", slot-scope="props")
      div
        span {{ $t(`ota_site.${props.rowData.source}`) }}

</template>

<script>
import Vuetable from 'vuetable-2/src/components/Vuetable'
import { cloneDeep } from 'lodash'
import { bus } from '@/bus.js'
// TODO: uncomment after unblock grouping competitors card
// import hideCompetitors from '@/mixins/hide-competitors'

export default {
  components: {
    Vuetable
  },

  // TODO: uncomment after unblock grouping competitors card
  // mixins: [hideCompetitors],
  props: {
    property: {
      type: Object,
      default() {
        return {}
      }
    },
    competitors: {
      type: Array,
      default() {
        return []
      }
    },
    tableHeight: {
      type: String,
      default: '600px'
    },
    sortingOrder: {
      type: Object,
      default() {
        return {}
      }
    },
    competitorRow: {
      type: Number,
      default () {
        return -1
      }
    },
    printMode: Boolean
  },

  data() {
    return {
      sortingOrderDup: [cloneDeep(this.sortingOrder)],
      loading: true,
      css: {
        table: {
          ascendingIcon: 'fas fa-chevron-up',
          descendingIcon: 'fas fa-chevron-down'
        }
      },
      fields: [
        {
          name: '__slot:number',
          title: '#',
          sortField: 'number',
          titleClass: 'number-column',
          dataClass: 'number-column'
        },
        {
          name: 'property_name',
          title: () => this.$t('competitors_table.name'),
          sortField: 'property_name',
          titleClass: 'name-column',
          dataClass: 'name-column'
        },
        {
          name: '__slot:distance',
          title: () => this.$t('competitors_table.distance'),
          sortField: 'distance',
          titleClass: 'distance-column',
          dataClass: 'distance-column'
        },
        {
          name: 'layout',
          title: () => this.$t('competitors_table.layout'),
          sortField: 'order_by_layout',
          titleClass: 'layout-column',
          dataClass: 'layout-column'
        },
        {
          name: '__slot:area',
          title: () => this.$t('competitors_table.area'),
          sortField: 'area',
          titleClass: 'area-column',
          dataClass: 'area-column'
        },
        {
          name: 'min_to_closest_train_bus',
          title: () => this.$t('competitors_table.time_nearest_station'),
          sortField: 'min_to_closest_train_bus',
          titleClass: 'closeset-station-column',
          dataClass: 'closeset-station-column'
        },
        {
          name: '__slot:building_structure',
          title: () => this.$t('competitors_table.building_structure'),
          sortField: 'building_structure',
          titleClass: 'building-structure-column',
          dataClass: 'building-structure-column'
        },
        {
          name: 'age',
          title: () => this.$t('competitors_table.age'),
          sortField: 'age',
          titleClass: 'age-column',
          dataClass: 'age-column'
        },
        {
          name: '__slot:basic_unit_price',
          title: () => this.$t('competitors_table.basic_unit_price'),
          sortField: 'basic_unit_price',
          titleClass: 'unit-price-column',
          dataClass: 'unit-price-column'
        },
        {
          name: '__slot:rent_fee',
          title: () => this.$t('competitors_table.rent_fee'),
          sortField: 'month_money',
          titleClass: 'rent-fee-column',
          dataClass: 'rent-fee-column'
        },
        {
          name: '__slot:source',
          title: () => this.$t('competitors_table.ota_site'),
          sortField: 'source',
          titleClass: 'ota-site',
          dataClass: 'ota-site'
        }
      ]
    }
  },

  computed: {
    localData() {
      return {
        data: this.competitors
      }
    }
  },

  mounted() {
    bus.$on('clickTooltip', (number) => {
      this.$emit('findCompetitor', number)
    })

    if (this.competitorRow != -1) {
      this.scrollToCompetitor(this.competitorRow)
    }
    if (this.competitorRow == -1) {
      setTimeout(() => {
        let active = document.querySelectorAll('.active-competitor')[0]
        if (active && !this.clickOnCompetitor) {
          active.classList.remove("active-competitor")
        }
      }, 100)
    }
  },

  methods: {
    dataManager(sortOrder) {
      const { sortField, direction } = sortOrder[0] || this.sortingOrder

      if (sortField != this.sortingOrder.sortField || direction != this.sortingOrder.direction) {
        this.$emit('sorting', sortOrder[0])
        bus.$emit('sortingCompetitors', sortOrder[0])
      }

      return { data: this.competitors }
    },

    scrollToCompetitor(row) {
      setTimeout(() => {
        let element = document.querySelectorAll('.number')[row - 1]
        let tr = element.parentElement.parentElement
        let list = document.querySelectorAll('.vuetable-body-wrapper')[0]
        let y = tr.offsetTop
        tr.classList.add('active-competitor')
        list.scrollTop = y
      }, 500)
    }
  }
}
</script>
<style lang="scss" scoped>
.competitors-list {
  ::v-deep .vuetable {
    .vuetable {
      width: 100% !important;
    }

    td {
      &.number-column {
        width: 4%;
      }

      &.name-column {
        width: 24%;

        span {
          cursor: pointer;
          margin-left: 5px;
        }
      }

      &.distance-column {
        width: 7%;
      }

      &.layout-column {
        width: 6%;
      }

      &.area-column {
        width: 7%;
      }

      &.closeset-station-column {
        width: 9%;
      }

      &.building-structure-column {
        width: 7%;
      }

      &.age-column {
        width: 7%;
      }

      &.unit-price-column {
        width: 7%;
      }

      &.rent-fee-column {
        width: 11%;
      }

      &.ota-site {
        width: 14%;
      }
    }

    th {
      color: #7c91a7;
      font-size: 9px;
      padding: 10px 0;

      &:hover {
        color: #009cea !important;
      }

      .sort-icon {
        float: none !important;
        font-family: "Font Awesome 5 Free", sans-serif;
        font-size: 10px;
        font-style: normal;
        font-variant: normal;
        font-weight: 900;
        line-height: 1;
        margin-left: 2px;
        text-rendering: auto;

        &::before {
          content: "\f078";
        }

        &.fa-chevron-up::before {
          content: "\f077";
        }
      }

      &.number-column {
        width: 4%;
      }

      &.name-column {
        width: 24%;
      }

      &.distance-column {
        width: 7%;
      }

      &.layout-column {
        width: 6%;
      }

      &.area-column {
        width: 7%;
      }

      &.closeset-station-column {
        width: 9%;
      }

      &.building-structure-column {
        width: 7%;
      }

      &.age-column {
        width: 7%;
      }

      &.unit-price-column {
        width: 7%;
      }

      &.rent-fee-column {
        width: 11%;
      }

      &.ota-site {
        width: 14%;
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid #e7ecf4;
      }

      td {
        color: #313541;
        font-size: 14px;
        padding: 20px 0;

        &.name-column {
          max-width: 19%;
          min-width: 19%;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .icon-action {
        color: #7c91a7;
        font-size: 16px;

        &:hover {
          color: #009cea;
        }
      }

      .dropdown-toggle,
      .dropdown-toggle:focus,
      .dropdown-toggle:active {
        background: transparent !important;
        border: none;
        box-shadow: none;
        color: #7c91a7 !important;
        padding: 0;

        &::after {
          display: none;
        }
      }

      .dropdown-toggle:hover {
        background: transparent !important;
        border: none;
        box-shadow: none;
        color: #009cea !important;
      }
    }

    .active-competitor {
      background-color: rgba(1, 1, 1, 0.04);
      font-weight: 900;
    }
  }

  .hide-comparison-competitor {
    background-color: transparent;
    border: 0;
    color: #008bd0;
    font-size: 17px;
    font-weight: 900;
    margin-left: 1px;
  }

  ::v-deep .hidden-row {
    display: none !important;
  }
}
</style>
